import { useEffect, useState } from "react";

// Returns a usable image `src` string from a given
// file path, SVGs are converted to data URIs.
export const useImageSrc = ({path = '', responsive = false}) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    const ext = (path || '').split('.').pop()?.toLowerCase();
    if (ext === 'svg') {
      fetch(path)
      .then(res => res.text())
      .then(svg => {
        const cleaned = responsive ? svg.replace(/\s(width|height)="[^"]*"/g, '') : svg;
        setSrc(`data:image/svg+xml;utf8,${encodeURIComponent(cleaned)}`);
      })
      .catch(console.error);
    } else {
      setSrc(path);
    }
  }, [path, responsive]);

  return src;
}